import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models/product-with-attributes';
import { Component, Input } from 'angular-ts-decorators';
import { CustomizerEvents } from '../models/customizer-events';
import { notifySubscribers } from '../utils/notify-subscribers';

import template from './find-retailer.component.html';

@Component({
  selector: 'findRetailer',
  template,
})
export class FindRetailerComponent {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public label?: string;
  @Input() public group?: IProductWithAttributes;

  public onFindRetailerClick() {
    notifySubscribers(CustomizerEvents.FindRetailerClick, this.group);
  }
}
